module.exports = __webpack_public_path__ + "static/media/SBL-01.6ead5dc9.jpg";